/* @flow */
import { AppState } from 'react-native';

import {
  handleAppBecameActive,
  handleIsConnectedChange,
} from './actions';


export default (dispatch: Dispatch) => {
  const handleAppStateChange = (newState: ?string) => {
    if (newState === 'active') {
      dispatch(handleAppBecameActive());
    }
  };

  handleAppStateChange(AppState.currentState);

  AppState.addEventListener('change', handleAppStateChange);
  window.addEventListener('online', () => dispatch(handleIsConnectedChange(true)));
  window.addEventListener('offline', () => dispatch(handleIsConnectedChange(false)));
  dispatch(handleIsConnectedChange(window.navigator.onLine));
};
